
import {stringToByte, byteToString} from '@/libs/stringutil'
import jcicp from '@/proto/jcicp.js'

export function jcicpEncode(frameTypeName, protobufData) {
  let strbytes = stringToByte(frameTypeName)
  let nameLength = strbytes.length
  let frameLength = strbytes.length + protobufData.length + 8
  let ds = []
  ds.push(0x7e)
  ds.push((frameLength >>> 8) & 0xff, (frameLength) & 0xff)
  ds.push((nameLength >>> 8) & 0xff, (nameLength) & 0xff)
  strbytes.forEach(c => {
    ds.push(c)
  })
  protobufData.forEach(c => {
    ds.push(c)
  })
  ds.push(0, 0, 0x7e)
  return Uint8Array.from(ds)
}

export function jcicpDecode(baseFrameData) {
  try {
    baseFrameData = new Uint8Array(baseFrameData)
    let frameLength = ((baseFrameData[1] << 8) | baseFrameData[2])
    let nameLength = ((baseFrameData[3] << 8) | baseFrameData[4])
    // let nameLength = baseFrameData[4]
    let crc = ((baseFrameData[frameLength - 3] << 8) | baseFrameData[frameLength - 2])
    let nameBytes = baseFrameData.slice(5, 5 + nameLength)
    let frameBytes = baseFrameData.slice(5 + nameLength, 5 + nameLength + (frameLength - 8 - nameLength))
    // console.log(frameLength)
    // console.log(baseFrameData)
    // console.log(frameBytes)
    let name = byteToString(nameBytes)
    let frameBuilder = jcicp.lookup(name)
    let frame = frameBuilder.decode(frameBytes)
    return {
      frameTypeName:name,
      frameBuilder:frameBuilder,
      frame:frame
    }
  } catch(err) {
    console.log('解码失败')
    console.log(err)
  }
}
